import React, { Component } from 'react';
import styled from 'styled-components';
import { Typo, Icon } from 'tmt-ui-kit';
import Link from '~/components/Link/Link';

const NoResultContainer = styled.div`
  background: ${props => props.theme.blueGray};
  padding: 28px 18px;
  border-radius: 4px;

  h2, p {
    margin: 0px;
  }
  h2 {
    margin-bottom: 12px;
  }
`;

const ContentText = styled.div`
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 600px){
    display: block;
  }
`;

const CenteredParagraph = styled(Typo.Paragraph)`
  display: flex;
  align-items: flex-start;
  color: ${props => props.theme.blue} !important; 
  font-weight: 600 !important;
`;

const TextContainer = styled.div`
  @media only screen and (max-width: 600px){
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
  }
`;

export default class NotResult extends Component {
  render() {
    return (
      <NoResultContainer>
        <Typo.HeaderTwo>Customize your tour</Typo.HeaderTwo>
        <ContentText>
          <Typo.Paragraph>We currently don&#39;t have any trip for this activity, but simply get in touch with us and we can customize a tour just for you.</Typo.Paragraph>
          <TextContainer>
            <Link to="/customize">
              <CenteredParagraph>
                <span>Customize </span>
                <Icon name="chevron-right" />
              </CenteredParagraph>
            </Link>
          </TextContainer>
        </ContentText>
      </NoResultContainer>
    );
  }
}
